import { render } from "./barreRisultato.vue?vue&type=template&id=3606448e&scoped=true&ts=true"
import script from "./barreRisultato.vue?vue&type=script&lang=ts"
export * from "./barreRisultato.vue?vue&type=script&lang=ts"

import "./barreRisultato.vue?vue&type=style&index=0&id=3606448e&scoped=true&lang=css"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3606448e"]])

export default __exports__